// src/components/Layout/CommonHeader.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import M2TLogo from "./M2TLogo";

export default function CommonHeader() {
  const navigate = useNavigate();

  return (
    <header className="w-full bg-black text-white">
      <div className="mx-auto flex max-w-7xl items-center justify-start px-6 py-3 md:py-4">
        {/* ─── Logo + Brand ─── */}
        <div
          className="flex cursor-pointer items-center gap-2"
          onClick={() => navigate("/")}
          aria-label="Go to homepage"
        >
          <M2TLogo className="h-[1.75rem] sm:h-[2.4rem] md:h-[2.8rem]" />
          {/* <div className="leading-tight text-left">
            <div className="font-semibold text-lg sm:text-xl md:text-2xl text-white">
              Million2Trillion
            </div>
            <div className="text-[9px] sm:text-[10px] md:text-xs tracking-wide text-gray-400">
              AI-Powered <span className="text-gray-300">Market Network</span>
            </div>
          </div> */}
        </div>
      </div>
    </header>
  );
}
